/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserResponse from './UserResponse';

/**
* The GroupResponse model module.
* @module model/GroupResponse
* @version 2020-12-7
*/
export default class GroupResponse {
    /**
    * Constructs a new <code>GroupResponse</code>.
    * グループ
    * @alias module:model/GroupResponse
    * @class
    * @param id {Number} グループID
    * @param name {String} グループ名
    * @param type {String} タイプ
    * @param address {String} 住所
    * @param tel {String} 電話番号
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(id, name, type, address, tel, updatedAt) {
        
        
        this['id'] = id;
        this['name'] = name;
        this['type'] = type;
        this['address'] = address;
        this['tel'] = tel;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>GroupResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GroupResponse} obj Optional instance to populate.
    * @return {module:model/GroupResponse} The populated <code>GroupResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GroupResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('representative')) {
                obj['representative'] = UserResponse.constructFromObject(data['representative']);
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [GroupResponse]);
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * グループID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * グループ名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * タイプ
    * @member {String} type
    */
    'type' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * @member {module:model/UserResponse} representative
    */
    'representative' = undefined;
    /**
    * 子会社
    * @member {Array.<module:model/GroupResponse>} children
    */
    'children' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
